"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.headers.common["Authorization"] = "jsport_backend_web";
axios.defaults.headers.common["ds"] = "ds1";
//axios.defaults.headers.common["gcb_token"] = store.getters.userToken;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
  //  config.headers.common["gcb_token"] = 
  // console.log('ddd',store.getters.userToken);
    Object.assign(config.headers.common,{"gcb_token":store.getters.userToken})
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
